/* eslint linebreak-style: ["error", "windows"] */
import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import router from './router';
import './formdesigner.js';
import constants from './constants';
import store from './store.js';
import 'dropzone/dist/dropzone.css'

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.config.ignoredElements = [/^mosaic-/, /^app-root/];

const configUrl = `${constants.BASE_URL}/config`;
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	render: (h) => h(App)
});
